import { render, staticRenderFns } from "./IconClothes.vue?vue&type=template&id=1477ffcc&"
import script from "./IconClothes.vue?vue&type=script&lang=js&"
export * from "./IconClothes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports